<template>
	<div class="my-collect">
		<!-- <Header title="我的收藏"></Header> -->
		<div class="content">
			<div class="search">
				<van-field v-model="form.condition.title" clearable placeholder="请输入搜索内容" />
				<span @click="refresh"> 搜索 </span>
			</div>

			<van-list v-model="loading" :finished="finished" finishedText="No More" @load="onLoad">
				<div class="goods-list">
					<div class="listItem" v-for="item,index in list" :key="item.id">
						<router-link :to="`/classify/commodity/details/${item.goods.id}`" class="list" v-if="!item.deleted">
							<img :src="item.goods.thumb" alt="" class="goods-thumb" />
							<p class="goods-title">{{ item.goods.title }}</p>
							<div class="goods-market">
								<span>¥{{ item.goods.marketPrice }}</span>
								<img @click.stop.prevent="del(item, index)" src="../../assets/img/car/del@2x.png" class="icon"
									alt="" />
							</div>
						</router-link>
					</div>
				</div>
			</van-list>

		</div>
	</div>
</template>

<script>
	// import SimpleScrollList from "../../components/SimpleScrollList.vue";
	export default {
		components: {
			// SimpleScrollList
		},
		name: "",
		data() {
			return {
				value: "",
				form: {
					lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
					page: 1, // 必选 请求数据页码
					perPage: 10, // 必选 每页数据量
					condition: {
						title: ''
					}
				},
				loading: false,
				finished: false,
				list: [],
				scrollTop: 0,
			};
		},
		computed: {},
		beforeRouteLeave(to, from, next) {
			// console.log(document.documentElement.scrollTop,document.body.scrollTop,window.pageYOffset,222)
			this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
			// 设置下一个路由的 meta
			from.meta.keepAlive = true; 
			next();
		},
		beforeRouteEnter(to,from,next){
			next(vm =>{
				document.body.scrollTop = vm.scrollTop;
			})  
		},
		methods: {
			del(item, index) {
				this.$dialog
					.confirm({
						title: "取消收藏",
						message: "您确定取消收藏此商品吗？",
						cancelButtonText: "不了",
						confirmButtonText: "取消收藏",
						cancelButtonColor: "#1677FF",
						confirmButtonColor: "#1677FF",
						className: "confirm-dialog",
					})
					.then(() => {
						this.$post({
								url: "/portal/Shop",
								module: "Favorite",
								interface: "1100",
								data: {
									id: item.id,
								},
							})
							.then(() => {
								this.$toast("取消成功");
								// this.$func.sleep().then(this.refresh);
								// this.onLoad();
								this.$set(this.list[index], 'deleted', true);
							})
							.catch((err) => {
								this.$toast(err.message || "失败，请重试");
							});
					})
					.catch(() => {});
			},
			refresh() {
				this.loading = true;
				this.form.lastId = 0;
				this.form.page = 1;
				this.finished = false;
				this.list = [];
				this.onLoad();
			},
			// searchOnLoad(){
			// 	this.form.page++;
			// }
			onLoad() {
				this.$post({
					url: "/portal/Shop",
					module: "Favorite",
					interface: "1000",
					data: this.form,
				}).then((res) => {
					console.log("收藏列表", res);

					this.form.lastId = res.lastId;
					this.form.page++;
					this.list = this.list.concat(res.list);
					this.finished = res.currentPage >= res.lastPage;
					this.loading = false;
				});
			},
		},
	};
</script>

<style lang='less' scoped>
	.search {
		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
			width: 56px;
			height: 30px;
			background: #fd0212;
			color: #ffffff;
			font-size: 14px;
			border-radius: 15px;
			text-align: center;
			line-height: 30px;
			margin-left: 5px;
		}
	}





	/deep/ .van-cell {
		background: #f7f7f7;
		border-radius: 15px;
		padding: 6px;
	}

	.content {
		width: 100%;
		padding: 0 16px;
		height: calc(100vh - 40px);
		display: flex;
		flex-direction: column;

		.goods-list {
			width: 100%;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;


			.listItem {
				width: 48%;
				margin-top: 20px;

				.goods-thumb {
					width: 160px;
					height: 160px;
				}

				.goods-title {

					color: #333333;
					font-size: 14px;
					text-overflow: -o-ellipsis-lastline;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
					width: 160px;
					margin-bottom: 10px;
				}

				.goods-market {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;

					span {
						color: #f50152;
						font-size: 16px;
					}

					img {
						width: 22px;
						height: 22px;
					}
				}
			}
		}
	}

	/* .simple-scroll-lis {
		flex: 1;
	}
 */
	/* 	/deep/.list-inner {
		background: #ffffff;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.list {
			width: 48%;
			margin-top: 20px;

			.icon {
				width: 22px;
				height: 22px;
			}

			div {
				color: #f50152;

				&>img {
					vertical-align: middle;
					float: right;
				}
			}

			p {
				color: #333333;
				font-size: 14px;
				text-overflow: -o-ellipsis-lastline;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				line-clamp: 2;
				-webkit-box-orient: vertical;
				width: 160px;
				margin-bottom: 10px;
			}

			&>img {
				width: 160px;
				height: 160px;
				background-color: #eee;
			}
		}
	} */
</style>
